import '.bt{flex-shrink:0;}.ssr-plugin'
import '.bu{width:20rem;}.ssr-plugin'
import '.ad{border:var(--blue-border);}.ssr-plugin'
import '.bf{background-color:var(--shades-beige-100);}.ssr-plugin'
import '.am{border-radius:1.25rem;}.ssr-plugin'
import '.bv{padding:1rem;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.d{gap:2rem;}.ssr-plugin'
import '.bw{align-items:flex-start;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Children, isValidElement, PropsWithChildren, ReactNode } from 'react'
import useMediaQuery from '@app/util/useMediaQuery'
import { LeftSidebarMobile } from './LeftSidebar.mobile'

interface SidebarProps extends PropsWithChildren {
  style?: Style
  collapsedButtonLabel?: string
}

const Sidebar = ({ children, style }: SidebarProps) => {
  return (
    <styled.aside className="bt bu ad bf am bv"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

const LeftSidebarRoot = ({ children }: PropsWithChildren) => {
  const isMobile = useMediaQuery()
  const childrenArray = Children.toArray(children)
  let sidebar: ReactNode = null
  const content: ReactNode[] = []

  for (const child of childrenArray) {
    if (isValidElement(child)) {
      if (child.type === Sidebar) {
        sidebar = child
      } else {
        content.push(child)
      }
    }
  }

  if (isMobile) {
    return <LeftSidebarMobile sidebar={sidebar} content={content} />
  }

  return (
    <div className="a d bw"
    >
      {sidebar}
      {content}
    </div>
  )
}

export const LeftSidebar = Object.assign(LeftSidebarRoot, {
  Sidebar,
})
